module.exports = __webpack_public_path__ + "static/media/xcode.f909b843.png";